export default "__VITE_ASSET__BdeZJd42__"